import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Analyst } from '../entities/boerse/analyst.entity';
import { Kursziel } from '../entities/boerse/kursziel.entity';
//#endregion

@Injectable()
export class AnalystService extends ODataEntityService<Analyst> {
  constructor(protected client: ODataClient) {
    super(client, 'Analyst', 'entities.boerse.Analyst');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public kursziele(entity: EntityKey<Analyst>): ODataNavigationPropertyResource<Kursziel> {
    return this.entity(entity).navigationProperty<Kursziel>('kursziele');
  }
  //#endregion
}
